import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconXStyle0 = gravityIconIndividualCss;

const GravityIconX = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'b1528c14611ddd947b441e192ee7a9e438dde875', color: this.color, size: this.size }, h("svg", { key: '0d9d58b6f52f0ecff55c0dfa2396cdcd79eb9862', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8da35ac430303aed6a10073626db5e54b1f40ca5', d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661l-6.338-9.225Zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121l-4.218-6.033Z", fill: "currentColor" }))));
    }
};
GravityIconX.style = GravityIconXStyle0;

export { GravityIconX as gravity_icon_x };

//# sourceMappingURL=gravity-icon-x.entry.js.map